import { render, staticRenderFns } from "./NewSkinComponent.vue?vue&type=template&id=78528bd9&"
import script from "./NewSkinComponent.vue?vue&type=script&lang=ts&"
export * from "./NewSkinComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports